
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/articles",
      function () {
        return require("private-next-pages/airlines/articles.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/articles"])
      });
    }
  